export default "__VITE_ASSET__B5zE1Gst__"